import { createApp } from 'vue';
import App from './index.vue';
import router from './router';
import { printVersion } from './utils/version';
import { setupNaive } from '@/utils/naive';
import { setupStore } from './store';

/**
 * bootstrap
 */
function bootstrap(): void {
    printVersion();
    const app = createApp(App);
    setupNaive(app);
    // 挂载状态管理
    setupStore(app);
    app.use(router);
    app.mount('#app', true);
}

bootstrap();
